import React from 'react';
import './Steps.scss';

const Steps = ({ length, currentStep, onClick }) => {
    let steps = [];
    for (let i = 0; i < length; i++) {
        steps.push(
            <div key={i} className={`step ${(i <= currentStep) ? 'active' : ''}`} onClick={e => onClick(i)}></div>
        )
    }
    return (
        <div className="steps">
            {steps}
        </div>
    )
}

export default Steps;


// WEBPACK FOOTER //
// ./src/components/ui/Steps/Steps.js